module.exports = __webpack_public_path__ + "static/img/img1.15d24f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/img1.png
// module id = 8z+k
// module chunks = 23